module.exports = __webpack_public_path__ + "static/media/conditions-treated.71ec8fc6.svg";